// extracted by mini-css-extract-plugin
export default {"root":"CD2CE7Mw1sM5xNK9tKVc","option":"NslyWgVVDsWFpefX2j81","placeholder":"imvqVzx4f6aJCtRQIgbG"};